// src/components/common/Alert.jsx
export const Alert = ({ children, variant = "info", onClose }) => {
  const variants = {
    success: { backgroundColor: "#dcfce7", color: "#166534", border: "1px solid #bbf7d0" },
    error: { backgroundColor: "#fee2e2", color: "#991b1b", border: "1px solid #fecaca" },
    warning: { backgroundColor: "#fef3c7", color: "#92400e", border: "1px solid #fde68a" },
    info: { backgroundColor: "#dbeafe", color: "#1e40af", border: "1px solid #bfdbfe" }
  };

  const style = {
    padding: "16px 20px",
    borderRadius: "8px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    ...variants[variant]
  };

  return (
    <div style={style}>
      <span>{children}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "20px",
            color: "inherit",
            opacity: 0.7,
            padding: "0 0 0 12px"
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};